export default __webpack_public_path__ + "static/media/Lock.ce3a691d.svg";